import React, { Component } from 'react';
import { connect } from 'react-redux';
import TradesView from './Trades.view';

import { getGroupedTrades } from './Trades.selectors';
import { saveViewedData } from "./Trades.helper";

export class TradesContainer extends Component {
  constructor(props){
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.createTradeToken = this.createTradeToken.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.gotToTrade = this.gotToTrade.bind(this);
    this.toggle = this.toggle.bind(this);
    this.downloadTrades = this.downloadTrades.bind(this);
  }

  componentDidMount() {
    const { location, lastFetchedTrades } = this.props;
    if(location.query.tradeId){
      this.gotToTrade(location.query.tradeId);
    }
    this.getTrades(this.getContext(), this.props, true);
    this.intervalId = setInterval(()=>{
      this.getTrades(this.getContext(), this.props);
    }, 5000);
  }

  componentWillReceiveProps(nextProps){
    const nextContext = this.getContext(nextProps);
    const contextSwitch = this.getContext() !== nextContext;

    const nextTradeId = nextProps.location.query.tradeId;
    if(nextTradeId && nextTradeId !== this.props.location.query.tradeId){
      this.gotToTrade(nextTradeId);
    }
    if(
      contextSwitch ||
      this.props.filtersFormState !== nextProps.filtersFormState ||
      this.props.page !== nextProps.page ||
      nextProps.refreshData
    ){
      this.getTrades(nextContext, nextProps, contextSwitch);
    }
  }

  getContext(propsOverride){
    const props = propsOverride || this.props;
    return props.match.params.context || 'open';
  }

  toggle(trade){
    const { dispatch, expanded } = this.props;
    const tradeId = trade.tradeId;
    const active = !expanded[tradeId];
    dispatch({
      type: 'TOGGLE_EXPANDED',
      payload: {
        tradeId,
        active,
      },
    });
  }

  gotToTrade(tradeId){
    const { dispatch } = this.props;
    dispatch({
      type: 'TRADE_FILTERS_CHANGE',
      payload: {
        filtersFormState: {
          data: {
            tradeId,
          }
        },
      }
    });
  };

  getTrades(context, props, fastLoad){
    const { dispatch, filtersFormState, page } = props;
    dispatch({
      type: 'FETCH_TRADES',
      payload: {
        filters: filtersFormState.data,
        page: page,
        fastLoad,
        context: context,
      }
    });
  }

  downloadTrades(s){
    const { dispatch, filtersFormState } = this.props;
    dispatch({
      type: 'DOWNLOAD_TRADES',
      payload: {
        filters: filtersFormState.data,
      }
    });
  }

  componentWillUnmount(){
    clearInterval(this.intervalId);
  }

  nextPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'TRADES_NEXT_PAGE',
    });
  }

  previousPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'TRADES_PREVIOUS_PAGE',
    });
  }

  createTradeToken({ tradeId, username }){
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_TRADE_TOKEN',
      payload: {
        username,
        tradeId
      }
    });
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'TRADE_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  render() {
    return (<TradesView
      {...this.props}
      onFilterChange={this.onFilterChange}
      downloadTrades={this.downloadTrades}
      createTradeToken={this.createTradeToken}
      nextPage={this.nextPage}
      previousPage={this.previousPage}
      gotToTrade={this.gotToTrade}
      toggle={this.toggle}
      context={this.getContext()}
    />);
  }

}

function mapStateToProps(state, ownProps) {
  const { auth, trades } = state;
  const context = ownProps.match.params.context || 'open';
  return {
    groups: getGroupedTrades(state, context),
    filtersFormState: trades.filtersFormState,
    lastFetchedTrades: trades.lastFetchedTrades,
    refreshData: trades.refreshData,
    user: auth.user,
    page: trades.page,
    expanded: trades.expanded,
  };
}

export default connect(mapStateToProps)(TradesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/Trades.container.js